import NiceModal from "@ebay/nice-modal-react";
import Table from "/src/components/table";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import optOutService from "/src/features/supervision/optOuts/services/optOutService";
import { formatDateWithoutSeconds } from "/src/utils/dateWithoutSeconds";
import hasPermission from "/src/utils/hasPermission";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import "../../OptOuts.css";

function OptOutsTable() {
    const toast = useToastDispatchContext();

    const cells = [
        { column: "Destination", name: "destination" },
        { column: "Kind", name: "destination_kind", show: (value) => <span className="opt-out-kind">{value}</span> },
        { column: "Channel", name: ["channel.name", "channel.type"], show: ([name, type]) => (name ? `${name}${type ? ` (${type})` : ""}` : "-") },
        { column: "Keyword", name: "keyword", show: (value) => value || "-" },
        // No sort header: the client sorts only the pages already scrolled in, while the server
        // always answers most recent first -- a partial reorder would read as the whole truth.
        { column: "Opted out at", name: "opted_out_at", show: (value) => formatDateWithoutSeconds(value) },
        {
            column: "State",
            name: ["active", "revoked_at"],
            show: ([active, revokedAt]) =>
                active ? (
                    <span className="opt-out-state opt-out-state--active">Active</span>
                ) : (
                    <span className="opt-out-state opt-out-state--lifted" title={`Lifted on ${formatDateWithoutSeconds(revokedAt)}`}>
                        Lifted {formatDateWithoutSeconds(revokedAt)}
                    </span>
                ),
        },
    ];

    const filters = [{ type: "input", placeholder: "Destination", name: "destination" }];

    // ApiModal resolves the error as readily as the response: what comes back is only a lifted
    // line when it carries an identifier.
    const onClickRevoke = ({ row, updateRow }) => {
        NiceModal.show(ApiModal, {
            title: "Lift opt-out",
            body: `Do you really want to lift the opt-out of ${row.destination} ? The line stays in the registry, marked as lifted.`,
            api: {
                request: optOutService.revoke,
                param: [row.id],
            },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" }, onClick: () => {} },
                { className: "cancel", label: "Lift", type: "submit" },
            ],
        }).then((result) => {
            if (result == null || result.id == null) {
                toast.error("Opt-out not lifted", (result && result.message) || "The line was left untouched, see network section for more info");
                return;
            }

            updateRow(result);
        });
    };

    const actions = [
        hasPermission("update_conversation")
            ? {
                  className: "fas fa-undo action-button profil_action",
                  style: {},
                  title: "Lift this opt-out",
                  condition: "active",
                  condition_match: false,
                  onClick: onClickRevoke,
              }
            : null,
    ].filter((action) => action);

    return <Table name="opt-out" cells={cells} api={optOutService.getAll} actions={actions} buttons={[]} filters={filters} />;
}

export default OptOutsTable;
